export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
};

export const DEFAULT_PAGE_SIZE = 10;
